export default {
  type: 'tab',
  active: '0',
  tabType: 'border-card',
  display: (vm, { model }) => model.className !== 'action-area',
  onTabClick: (vm, tab, { model }) => {
    const { uiApp } = vm.mForm.editor.editorCore;
    const status = tab.name;
    const comp = uiApp.getComponent(model.id || model.name);
    comp && typeof comp.setDisabled === 'function' && comp.setDisabled(status === 'disabled');
  },
  items: [{
    title: '按钮默认状态',
    labelWidth: '100px',
    items: [{
      name: 'text',
      text: '按钮文案',
    }, {
      type: 'component',
      id: 'background',
    }, {
      name: 'style',
      items: [{
        type: 'row',
        span: 8,
        items: [{
          type: 'component',
          id: 'font',
        }],
      }],
    }],
  }, {
    title: '按钮置灰状态',
    status: 'disabled',
    labelWidth: '100px',
    items: [{
      name: 'disabledText',
      text: '按钮文案',
    }, {
      type: 'component',
      id: 'disabledBackground',
    }, {
      name: 'disabledStyle',
      items: [{
        type: 'row',
        span: 8,
        items: [{
          type: 'component',
          id: 'font',
        }],
      }],
    }],
  }],
};
